<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form :model="queryParams" ref="dltForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="起始期数">
        <el-input v-model="queryParams.startPeriod" placeholder="开始期数" clearable style="width: 100px;"/>
        -
        <el-input v-model="queryParams.endPeriod" placeholder="结束期数" clearable style="width: 100px;"/>
      </el-form-item>
      <el-form-item label="前区1" prop="redOne">
        <el-input v-model="queryParams.redOne" placeholder="前区1" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="前区2" prop="redTwo">
        <el-input v-model="queryParams.redTwo" placeholder="前区2" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="前区3" prop="redThree">
        <el-input v-model="queryParams.redThree" placeholder="前区3" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="前区4" prop="redFour">
        <el-input v-model="queryParams.redFour" placeholder="前区4" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="前区5" prop="redFive">
        <el-input v-model="queryParams.redFive" placeholder="前区5" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="后区1" prop="blueOne">
        <el-input v-model="queryParams.blueOne" placeholder="后区1" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="后区2" prop="blueTwo">
        <el-input v-model="queryParams.blueTwo" placeholder="后区2" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQueryDlt">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQueryDlt">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:dlt:init']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleInitAllDlt">全部初始化
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:dlt:fill']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleFillDltHistory">
          补全历史数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:dlt:count']" type="danger" plain icon="el-icon-data-line" size="mini" @click="handleDltDataLine">号码频率
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:dlt:export']" type="warning" plain icon="el-icon-export" size="mini" @click="handleExportDlt">导出</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:dlt:initC']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleInitAllDltC">
          初始化统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:dlt:exportC']" type="warning" plain icon="el-icon-export" size="mini" @click="handleOpenC()">导出统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:dlt:cache']" type="danger" plain icon="el-icon-export" size="mini" @click="handleRefreshDlt">刷新缓存</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:dlt:gen']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleOpenGenerateDlt">
          生成大乐透
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:dlt:exportF']" type="warning" plain icon="el-icon-export" size="mini" @click="exportFrequency">导出组合频率
        </el-button>
      </el-col>
      <right-toolbar :show-search.sync="showSearch" @queryTable="getDltList" />
    </el-row>
    <el-table :data="dltList" v-loading="loading" border highlight-current-row
              :cell-class-name="cellClassName">
      <el-table-column label="期号" align="center" prop="period"/>
      <el-table-column label="前区号码" align="center">
        <el-table-column label="1" align="center" prop="redOne"/>
        <el-table-column label="2" align="center" prop="redTwo"/>
        <el-table-column label="3" align="center" prop="redThree"/>
        <el-table-column label="4" align="center" prop="redFour"/>
        <el-table-column label="5" align="center" prop="redFive"/>
      </el-table-column>
      <el-table-column label="后区号码" align="center">
        <el-table-column label="1" align="center" prop="blueOne"/>
        <el-table-column label="2" align="center" prop="blueTwo"/>
      </el-table-column>
      <el-table-column label="奖池金额" align="right" prop="pondAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatYuan(scope.row.pondAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="一等奖" align="center">
        <el-table-column label="注数" align="center" prop="firstCount"/>
        <el-table-column label="奖金(元)" align="right" prop="firstAmount" min-width="90px">
          <template slot-scope="scope">
            {{ formatYuan(scope.row.firstAmount) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="二等奖" align="center">
        <el-table-column label="注数" align="center" prop="secondCount"/>
        <el-table-column label="奖金(元)" align="right" prop="secondAmount">
          <template slot-scope="scope">
            {{ formatYuan(scope.row.secondAmount) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="销售金额" align="right" prop="saleAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatYuan(scope.row.saleAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="开奖日期" align="center" prop="lotteryDate" min-width="90px">
        <template slot-scope="scope">
          {{ scope.row.lotteryDate | date }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="210px">
        <template slot-scope="scope">
          <el-button v-hasPermi="['lottery:dlt:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
          <el-button v-hasPermi="['lottery:dlt:next']" type="text" icon="el-icon-medal" @click="handleNextHistory(scope.row.period)">下期</el-button>
          <el-button v-hasPermi="['lottery:dlt:nextF']" type="text" icon="el-icon-medal" @click="handleNextNum(scope.row.period)">频率</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getDltList"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
    />
    <!-- 数字次数图表弹出层 -->
    <el-dialog :title="countTitle" :visible.sync="countOpen" width="1500px" @closed="countClosed"
               :close-on-click-modal="false">
      <div ref="redChart" style="width:100%;height: 300px;"></div>
      <div ref="blueChart" style="width:100%;height: 300px;margin-top: 20px"></div>
    </el-dialog>
    <!-- 导出统计次数弹出层 -->
    <el-dialog :title="cTitle" :visible.sync="cOpen" width="300px" :close-on-click-modal="false">
      <el-form ref="cForm" :model="cForm" :rules="cRules" label-width="110px" label-suffix="：">
        <el-form-item prop="isC">
                    <span slot="label">
                      是否排序
                      <el-popover
                        placement="top-start"
                        width="250"
                        trigger="hover"
                        content="如果排序为是，导出数据号码为历史出现次数从多到少的顺序;否则按照数据号码从小到大排序">
                        <i slot="reference" class="el-icon-question"></i>
                      </el-popover>
                    </span>
          <el-select v-model="cForm.isC" placeholder="请选择是否" style="width: 140px">
            <el-option :key="true" label="是" :value="true"></el-option>
            <el-option :key="false" label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportC">导出</el-button>
        <el-button @click="cancelC">取消</el-button>
      </div>
    </el-dialog>

    <!-- 生成大乐透弹出层 -->
    <el-dialog title="生成大乐透" :visible.sync="generateDltOpen" width="750px" :close-on-click-modal="false">
      <el-form ref="generateDltForm" :model="generateDltForm" :inline="true" :rules="generateDltRules"
               label-width="80px">
        <el-form-item label="生成个数" prop="count">
          <el-select v-model="generateDltForm.count" placeholder="请选择个数">
            <el-option :key="1" label="1" :value="1"/>
            <el-option :key="5" label="5" :value="5"/>
            <el-option :key="10" label="10" :value="10"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleGenerateDlt">生成</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetGenerateDlt">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="generateDltList" border style="width: 100%" :cell-class-name="cellClassName"
                highlight-current-row>
        <el-table-column label="前区号码" align="center">
          <el-table-column label="1" align="center" prop="redOne"/>
          <el-table-column label="2" align="center" prop="redTwo"/>
          <el-table-column label="3" align="center" prop="redThree"/>
          <el-table-column label="4" align="center" prop="redFour"/>
          <el-table-column label="5" align="center" prop="redFive"/>
        </el-table-column>
        <el-table-column label="后区号码" align="center">
          <el-table-column label="1" align="center" prop="blueOne"/>
          <el-table-column label="2" align="center" prop="blueTwo"/>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-hasPermi="['lottery:dlt:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 往期中奖概率弹出层 -->
    <el-dialog title="往期中奖概率" :visible.sync="winningOpen" width="500px">
      <el-row :gutter="20" v-for="(item,index) in winningList" :key="index" style="padding: 5px 0">
        <el-col :span="8">{{ item.name }}</el-col>
        <el-col :span="8">注数：{{ item.count }}</el-col>
        <el-col :span="8">概率：{{ formatMoney(item.winningRate * 100, 2) }}%</el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="winningOpen=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 下期大乐透同期历史数据弹出层 -->
    <el-dialog :title="dltHistoryTitle" :visible.sync="dltHistoryOpen" width="1500px" :close-on-click-modal="false">
      <el-tabs v-model="activeDltHistoryName" type="border-card">
        <el-tab-pane label="历史同期数据" name="firstDlt">
          <el-table :data="dltHistoryList" border style="width: 100%" :cell-class-name="cellClassName"
                    highlight-current-row>
            <el-table-column label="期数" align="center" prop="period" width="70"/>
            <el-table-column label="前区号码" align="center">
              <el-table-column label="1" align="center" prop="redOne" width="50"/>
              <el-table-column label="2" align="center" prop="redTwo" width="50"/>
              <el-table-column label="3" align="center" prop="redThree" width="50"/>
              <el-table-column label="4" align="center" prop="redFour" width="50"/>
              <el-table-column label="5" align="center" prop="redFive" width="50"/>
            </el-table-column>
            <el-table-column label="后区号码" align="center">
              <el-table-column label="1" align="center" prop="blueOne" width="50"/>
              <el-table-column label="2" align="center" prop="blueTwo" width="50"/>
            </el-table-column>
            <el-table-column label="和值" align="center">
              <el-table-column label="前区" align="center" prop="redSum" width="50"/>
              <el-table-column label="后区" align="center" prop="blueSum" width="50"/>
              <el-table-column label="总和" align="center" prop="totalSum" width="50"/>
            </el-table-column>
            <el-table-column label="前区跨度" align="center" prop="redSpan" width="70"/>
            <el-table-column label="前区" align="center">
              <el-table-column label="奇数" align="center" prop="redOdd" width="50"/>
              <el-table-column label="偶数" align="center" prop="redEven" width="50"/>
            </el-table-column>
            <el-table-column label="后区" align="center">
              <el-table-column label="奇数" align="center" prop="blueOdd" width="50"/>
              <el-table-column label="偶数" align="center" prop="blueEven" width="50"/>
            </el-table-column>
            <el-table-column label="序号区间" align="center">
              <el-table-column label="一区(1-12)" align="center" prop="n1" width="90px"/>
              <el-table-column label="二区(13-24)" align="center" prop="n2" width="90px"/>
              <el-table-column label="三区(25-35)" align="center" prop="n3" width="90px"/>
            </el-table-column>
            <el-table-column label="次数区间" align="center">
              <el-table-column label="一区" align="center" prop="m1"/>
              <el-table-column label="二区" align="center" prop="m2"/>
              <el-table-column label="三区" align="center" prop="m3"/>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="统计数据" name="secondDlt">
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">前区次数排名：</el-col>
            <el-col :span="22">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in dltHistoryRedList" :key="item.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">未出现的前区：</el-col>
            <el-col :span="22"><span v-for="item in dltHistoryRedZeroList" :key="item">{{ item }} </span></el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">后区次数排名：</el-col>
            <el-col :span="22">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in dltHistoryBlueList" :span="2" :key="item.num"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #0000FF">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">未出现的后区：</el-col>
            <el-col :span="22"><span v-for="item in dltHistoryBlueZeroList" :key="item">{{ item }} </span></el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dltHistoryOpen=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 下期大乐透数字频率弹出层 -->
    <el-dialog :title="dltNumTitle" :visible.sync="dltNumOpen" width="1500px" :close-on-click-modal="false">
      <el-row :gutter="10">
        <el-col :span="2" style="text-align: right">前区-前区：</el-col>
        <el-col :span="22">
          <el-row v-for="item in redRedList" :key="item.num" :gutter="10">
            <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span
                  style="color: #d73a49">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider/>
      <el-row :gutter="10">
        <el-col :span="2" style="text-align: right">前区-后区：</el-col>
        <el-col :span="22">
          <el-row v-for="item in redBlueList" :key="item.num" :gutter="10">
            <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span
                  style="color: #0000FF">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider/>
      <el-row :gutter="10">
        <el-col :span="2" style="text-align: right">后区-前区：</el-col>
        <el-col :span="22">
          <el-row v-for="item in blueRedList" :key="item.num" :gutter="10">
            <el-col :span="1" style="color: #0000FF;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span
                  style="color: #d73a49">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider/>
      <el-row :gutter="10">
        <el-col :span="2" style="text-align: right">后区-后区：</el-col>
        <el-col :span="22">
          <el-row v-for="item in blueBlueList" :key="item.num" :gutter="10">
            <el-col :span="1" style="color: #0000FF;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span
                  style="color: #0000FF">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dltNumOpen=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  generateDlt,
  getDltNumData,
  getDltWinningData,
  getNextDltHistory,
  getNextNumFrequency,
  initAllDlt,
  initAllDltC,
  fillHistoryData,
  listDlt,
  refreshDltCache
} from '@/api/lottery/dlt'
import * as echarts from 'echarts'

export default {
  data() {
    return {
      activeName: 'first',
      // 遮罩层
      loading: '',
      showSearch:true,
      //大乐透数据
      dltList: [],
      // 大乐透数量
      total: 0,
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        startPeriod: null,
        endPeriod: null
      },
      countTitle: '',
      countOpen: false,
      redChart: {},
      blueChart: {},
      cTitle: '',
      cOpen: false,
      cForm: {},
      cRules: {
        isC: [
          {required: true, message: '是否不能为空', trigger: 'blur'}
        ]
      },
      generateDltOpen: false,
      generateDltForm: {
        count: 1
      },
      generateDltRules: {
        count: [
          {required: true, message: '个数不能为空', trigger: 'blur'}
        ]
      },
      generateDltList: [],
      winningList: [],
      winningOpen: false,
      activeDltHistoryName: 'firstDlt',
      dltHistoryOpen: false,
      dltHistoryTitle: '',
      dltHistoryList: [],
      dltHistoryRedList: [],
      dltHistoryRedZeroList: [],
      dltHistoryBlueList: [],
      dltHistoryBlueZeroList: [],

      dltNumTitle: '',
      dltNumOpen: false,
      redRedList: [],
      redBlueList: [],
      blueRedList: [],
      blueBlueList: [],
    }
  },
  created() {
    this.getDltList()
  },
  methods: {
    cellClassName({row, column, rowIndex, columnIndex}) {
      if (column.property) {
        if (column.property === 'redOne' || column.property === 'redTwo' || column.property === 'redThree' || column.property === 'redFour' || column.property === 'redFive') {
          return 'red-ball';
        } else if (column.property === 'blueOne' || column.property === 'blueTwo') {
          return 'blue-ball';
        }
      }
    },
    /** 查询大乐透数据 **/
    getDltList() {
      listDlt(this.queryParams).then(res => {
        this.dltList = res.rows;
        this.total = res.total
      })
    },
    /** 搜索大乐透列表  **/
    handleQueryDlt() {
      this.queryParams.current = 1;
      this.getDltList();
    },
    /** 重置大乐透按钮操作 */
    resetQueryDlt() {
      this.queryParams.startPeriod = undefined;
      this.queryParams.endPeriod = undefined;
      this.resetForm("dltForm");
      this.handleQueryDlt();
    },
    /** 初始化大乐透数据 **/
    handleInitAllDlt() {
      this.$modal.confirm("确定要初始化全部大乐透数据吗？确认后将全部重新生成！").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在初始化中，请稍后...")
          initAllDlt().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryDlt();
          }).catch(() => {
            this.$modal.closeLoading()
          })
        }
      }).catch(() => {
      })
    },
    /** 补全大乐透历史数据 **/
    handleFillDltHistory() {
      this.$modal.confirm("确定要补全大乐透历史数据吗？").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在补全中，请稍后...")
          fillHistoryData().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("补全成功")
            this.handleQueryDlt();
          }).catch(() => {
            this.$modal.closeLoading()
          })
        }
      }).catch(() => {
      })
    },
    /** 大乐透数据统计柱状图 **/
    handleDltDataLine() {
      this.countTitle = "大乐透数据统计柱状图";
      getDltNumData().then(res => {
        if (res.data.redData.length > 0) {
          let seriesData = res.data.redData.map(item => item.counts);
          let xAxisData = res.data.redData.map(item => item.num);
          this.redChart = echarts.init(this.$refs.redChart, "macarons");
          this.redChart.setOption({
            title: {
              text: '前区数据统计',
              left: 'center'
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross"
              }
            },
            color: ["#ff3c00"],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "0%",
              top: "10%",
              containLabel: true
            },
            xAxis: {
              data: xAxisData
            },
            yAxis: {},
            series: [
              {
                name: "次数",
                type: "bar",
                data: seriesData,
                label: {
                  show: true,
                  position: 'top',
                  formatter: function (data) {
                    return data.value
                  }
                }
              }
            ]
          });
        }
        if (res.data.blueData.length > 0) {
          let seriesData = res.data.blueData.map(item => item.counts);
          let xAxisData = res.data.blueData.map(item => item.num);
          this.blueChart = echarts.init(this.$refs.blueChart, "macarons");
          this.blueChart.setOption({
            title: {
              text: '后区数据统计',
              left: 'center'
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross"
              }
            },
            color: ["#0077ff"],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "0%",
              top: "10%",
              containLabel: true
            },
            xAxis: {
              data: xAxisData
            },
            yAxis: {},
            series: [
              {
                name: "次数",
                type: "bar",
                data: seriesData,
                label: {
                  show: true,
                  position: 'top',
                  formatter: function (data) {
                    return data.value
                  }
                }
              }
            ]
          });
        }
      })
      this.countOpen = true;
    },
    /** 导出大乐透按钮操作 */
    handleExportDlt() {
      this.download('/admin/lottery/dlt/export', {
        ...this.queryParams
      }, `大乐透导出_${new Date().getTime()}.xlsx`)
    },

    /** 初始化大乐透统计数据 **/
    handleInitAllDltC() {
      this.$modal.confirm("确定要初始化大乐透统计数据吗？").then(action => {
        if(action === 'confirm'){
          this.$modal.loading("正在初始化中，请稍后...")
          initAllDltC().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryDlt();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=>{ })
    },
    /** 刷新大乐透缓存 **/
    handleRefreshDlt() {
      refreshDltCache().then(() => {
        this.$modal.msgSuccess("刷新成功");
      })
    },
    /** 获奖概率弹窗 **/
    handleWinning(row) {
      this.winningList = [];
      let queryParams = {
        redOne: row.redOne,
        redTwo: row.redTwo,
        redThree: row.redThree,
        redFour: row.redFour,
        redFive: row.redFive,
        blueOne: row.blueOne,
        blueTwo: row.blueTwo,
        period: row.period
      }
      getDltWinningData(queryParams).then(res => {
        this.winningList = res.data
        this.winningOpen = true;
      })
    },
    /** 下期历史同期数据 **/
    handleNextHistory(period) {
      this.dltHistoryList = [];
      this.dltHistoryRedList = [];
      this.dltHistoryRedZeroList = [];
      this.dltHistoryBlueList = [];
      this.dltHistoryBlueZeroList = [];
      getNextDltHistory(period).then(res => {
        this.dltHistoryList = res.data.lotteryDataList;
        this.dltHistoryRedList = res.data.redList;
        this.dltHistoryRedZeroList = res.data.redZeroList;
        this.dltHistoryBlueList = res.data.blueList;
        this.dltHistoryBlueZeroList = res.data.blueZeroList;
        this.dltHistoryTitle = "【" + res.data.period + "】期大乐透历史同期统计";
        this.dltHistoryOpen = true;
      })
    },
    /** 打开生成大乐透弹窗 */
    handleOpenGenerateDlt() {
      this.generateDltOpen = true;
      this.$set(this.generateDltForm, 'count', 1)
      this.resetForm("generateDltForm");
      this.generateDltList = []
    },
    handleGenerateDlt() {
      this.$refs["generateDltForm"].validate(valid => {
        if (valid) {
          generateDlt(this.generateDltForm).then(res => {
            if (res.flag) {
              this.generateDltList = res.data
            }
          })
        }
      })
    },
    resetGenerateDlt() {
      this.generateDltList = []
      this.$set(this.generateDltForm, 'count', 1)
      this.resetForm("generateDltForm");
    },
    /** 打开导出彩票统计次数弹窗 **/
    handleOpenC() {
      this.cOpen = true;
      this.cTitle = "大乐透统计数据导出";
    },
    /** 导出统计次数 **/
    exportC() {
      this.$refs["cForm"].validate(valid => {
        if (valid) {
          this.download('/admin/lottery/dlt/exportC', {
            ...this.cForm
          }, `大乐透统计数据导出_${new Date().getTime()}.xlsx`)
        }
      });
    },
    cancelC() {
      this.cOpen = false;
      this.cForm = {};
      this.resetForm("cForm");
    },
    countClosed() {
      this.redChart.dispose();
      this.blueChart.dispose();
    },
    close() {
      this.generateDltOpen = false;
    },
    exportFrequency() {
      this.download('/admin/lottery/dlt/exportFrequency', {
        ...this.queryParams
      }, `大乐透数字组合频率导出_${new Date().getTime()}.xlsx`)
    },
    handleNextNum(period) {
      this.redRedList = [];
      this.redBlueList = [];
      this.blueRedList = [];
      this.blueBlueList = [];
      this.dltNumTitle = "【" + period + "】期大乐透下期数字频率";
      let params = {period: period, count: null}
      getNextNumFrequency(params).then(res => {
        this.redRedList = res.data.redRedList;
        this.redBlueList = res.data.redBlueList;
        this.blueRedList = res.data.blueRedList;
        this.blueBlueList = res.data.blueBlueList;
        this.dltNumOpen = true;
      })
    }

  }
}
</script>

